import React, { Fragment, useEffect, useState, useRef, useSelector } from "react";
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Label,
    FormGroup,
    Form,
    Badge
} from "reactstrap";
import GetLoader from "../../../../common/getLoader";
import { toast } from "react-toastify";
import OtpInput from 'react-otp-input';
import { useForm } from "react-hook-form";
import { calculateBulkCommission, fetchCommissionCalculation, verifyInvoiceOtpNormalWallet } from "../../../../../api";
import { getFromLocalStorage } from "../../../../../hooks/useLocalStorage";
import convertToRupees from "../../../../../utilities/convertToRupees";
import FileUploadComponent from "../../../../common/FileUpload";
import { USE_V2_WEBSOCKET } from "../../../../../constant";
import usePaymentWebSocket from '../../../../../hooks/usePaymentWebSocket';

const PayBulkInvoiceNormalWallet = ({ isOpen, toggle, selectedDocumentIds, offlinePayment, selectedInvoiceNumbers }) => {
    const [calculation, setCalculation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [redirecting, setRedirecting] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [activeStep, setActiveStep] = useState(0);
    const [documentCommissionDetails, setDocComDetails] = useState([]);
    const [wantInvoice, setWantInvoice] = useState(null);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [remark, setRemark] = useState("");
    const [termsModalOpen, setTermsModalOpen] = useState(false);
    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [mobileNoModalOpen, setMobileNoModalOpen] = useState(false);
    const [state, setState] = useState({ otp: '', mobileNumber: "" });
    const [invoiceNumber, setInvoiceNo] = useState("")

    const componentRef = useRef();
    const { register, setValue, trigger, getValues } = useForm();

    // ✅ Get Partnership ID from Local Storage
    const user = getFromLocalStorage("user");
    const role_id = getFromLocalStorage("ROLE")?.role_id;
    const partnership_id = user?.partnership_id;
    const businessPartnerInfo = user.partnerInfo;
    const isGSTReg = user?.partnerInfo.user.is_gst_registered || false;
    // ✅ Convert selectedDocumentIds object to an array

    // const documentIdsArray = Object.keys(selectedDocumentIds || {}).map(Number);
    const [documentIdsArray, setDocumentIdsArray] = useState([]);
    const [txnid, setTxnid] = useState(null); // Used for dynamic WebSocket connection

    // Connect WebSocket dynamically when txnid is available
    const { paymentEvent, clearEvent } = usePaymentWebSocket(txnid, USE_V2_WEBSOCKET && !!txnid);

    useEffect(() => {
        if (paymentEvent) {
            if (paymentEvent.status === 'SUCCESS' || paymentEvent.status?.toLowerCase() === 'completed') {
                setProcessing(false);
                setRedirecting(false);
                if (otpModalOpen) setOtpModalOpen(false);
                toggle(); // Close modal
                
                window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
          detail: {
            status: 'SUCCESS',
            message: 'Your wallet was successfully recharged!',
            documentInfo: paymentEvent.payload?.amount || calculation?.net_payable_amount || 0,
            documentLabel: 'Amount Recharged (INR):'
          }
        }));
        
        window.dispatchEvent(new Event('refresh-invoices')); // Instruct parent to refresh
      } else if (paymentEvent.status === 'FAILED' || paymentEvent.status?.toLowerCase() === 'failed') {
        setProcessing(false);
        setRedirecting(false);
        if (otpModalOpen) setOtpModalOpen(false);
        toggle(); // Close modal
        
        window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
          detail: {
            status: 'FAILED',
            message: 'Payment failed! Please try again.',
            documentInfo: paymentEvent.payload?.amount || calculation?.net_payable_amount || 0,
            documentLabel: 'Amount Attempted (INR):'
          }
        }));
            }
            clearEvent();
        }
    }, [paymentEvent, toggle, clearEvent, otpModalOpen, calculation, txnid]);

    useEffect(() => {
        if (documentCommissionDetails?.length > 0) {
            const docIds = documentCommissionDetails.map(item => item.document_id);
            setDocumentIdsArray(docIds);
        }
    }, [documentCommissionDetails])

    const toggleTermsModal = () => setTermsModalOpen(!termsModalOpen);
    const toggleOtpModal = () => setOtpModalOpen(!otpModalOpen);
    const toggleMobileNoModal = () => setMobileNoModalOpen(!mobileNoModalOpen);


    const handleAgreeClick = () => {
        setTermsAccepted(true);
        toggleTermsModal();
    };

    const handleChange = (otp) => setState({ otp });
    const handleInvoiceNumberChange = (invoiceNumber) => setInvoiceNo(invoiceNumber)

    // ✅ Fetch commission calculation from backend
    const fetchCalculation = async () => {
        console.log("fetchCalculation triggered", { isOpen, partnership_id, selectedInvoiceNumbers, documentIdsArray });
        if (!partnership_id || !selectedInvoiceNumbers?.length) return;
        setLoading(true);
        setErrorMessage("");
        setCalculation(null);

        try {
            const payload = {
                invoice_numbers: selectedInvoiceNumbers,
            };

            console.log("📤 Calling calculateBulkCommission API with payload:", payload);

            const response = await calculateBulkCommission(payload);

            console.log("📥 API Response:", response);
            //   const response = await fetchCommissionCalculation({
            //     document_ids: documentIdsArray,
            //     partnership_id,
            //     role_id: role_id
            //   });

            console.log("response.data.result.documentTxnList====", response.data.result.documentTxnList)
            if (response?.data?.result) {
                setCalculation(response.data.result);
                setDocComDetails(response.data.result.documentTxnList)

            } else {
                throw new Error("Invalid response from server.");
            }
        } catch (error) {
            const errorMsg =
                error.response?.data?.error || "An error occurred while fetching data.";
            setErrorMessage(errorMsg);
            toast.error(errorMsg);
        }
        setLoading(false);
    };

    // ✅ Fetch data when modal opens
    useEffect(() => {
        if (isOpen && selectedInvoiceNumbers?.length > 0) {
            console.log("PayBulkInvoiceNormalWallet modal opened with selectedInvoiceNumbers", selectedInvoiceNumbers);
            fetchCalculation();
            setActiveStep(0);
        }
    }, [isOpen, selectedInvoiceNumbers]);

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleProceedToPay = async () => {
        if (!calculation) return;

        setProcessing(true);
        // toast.info("Processing commission, please wait...");

        try {
            console.log("VIEW PAYLOAD++++++++++++", {
                // otp: state.otp,
                document_ids: documentIdsArray,
                partnership_id,
            });
            const response = await verifyInvoiceOtpNormalWallet({
                // otp: state.otp,
                document_ids: documentIdsArray,
                partnership_id,
                partner_invoice_number: invoiceNumber,
                invoice_numbers: selectedInvoiceNumbers,
                mobileNumber: state.mobileNumber
            });



            if (response?.data?.result.paymentResponse?.payuUrl && response?.data?.result?.paymentResponse?.payUPayload) {
                const payuUrl = response.data.result.paymentResponse.payuUrl;
                const payuPayload = response.data.result.paymentResponse.payUPayload;

                setTxnid(payuPayload.txnid); // Set txnid to trigger WebSocket connection
                toast.success("Redirecting to payment gateway...");
                setRedirecting(true);

                // Create a dynamic form for redirection with full payload
                const form = document.createElement("form");
                form.method = "POST";
                form.action = payuUrl;
                // Append all payload parameters as hidden inputs
                Object.entries(payuPayload).forEach(([key, value]) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit(); // Submit the form to PayU
            } else {
                throw new Error("Failed to process commission.");
            }
        } catch (error) {
            const errorMsg =
                error.response?.data?.error || "Failed to process commission.";
            setErrorMessage(errorMsg);
            toast.error(errorMsg);
        }

        setProcessing(false);
    };

    const offlineNormalPay = async (file, remark) => {
        try {
            let payload = {
                document_ids: documentIdsArray,
                partnership_id,
                supportedFile: file,
                isOfflinePayment: true,
                remark: remark || "",
                invoice_number: selectedInvoiceNumbers,
                partner_invoice_number: invoiceNumber || "",
            };
            console.log("Payload for Offline Normal Payment:", payload);

            const response = await verifyInvoiceOtpNormalWallet({
                ...payload
            });

            console.log("Response of Offline Normal Payment:", response);
            if (response?.data?.result) {
                const ticketNumber = response.data.result.ticketNumber;
                toast.success(`Tikcet ${ticketNumber} has been created successfully`);
            } else {
                throw new Error("Invalid response from server.");
            }
            toggle()
        } catch (error) {
            console.log("Error in Offline Normal Payment:", error);
            const errorMsg =
                error.response?.data?.error || "An error occurred while fetching data.";
            setErrorMessage(errorMsg);
            toast.error(errorMsg);
            toggle()
        }

    }

    const handleOfflineSubmit = async () => {
        if (isSubmitting) return;
        const formValues = getValues();
        if (!formValues.remark || formValues.remark.trim() === "") {
            toast.error("Please enter a remark before submitting.");
            return;
        }
        if (!formValues.file || (Array.isArray(formValues.file) && formValues.file.length === 0)) {
            toast.error("Please upload a file before submitting.");
            return;
        }
        console.log("Form Values:", formValues);
        setIsSubmitting(true);
        try {
            await offlineNormalPay(formValues.file, formValues.remark);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
                <div ref={componentRef} className="print_page m-15 p-0">


                    {activeStep === 0 && (
                        <>
                            <ModalHeader toggle={toggle} className="pb-0 mb-0 border-0">
                                {loading ? "Fetching Invoice Details..." : "Invoice Details"}
                            </ModalHeader>
                            <ModalBody>
                                {loading ? (
                                    <GetLoader />
                                ) : errorMessage ? (
                                    <div className="text-center text-danger">
                                        <h5>{errorMessage}</h5>
                                        <Button color="danger" onClick={toggle}>
                                            Close
                                        </Button>
                                    </div>
                                ) : (
                                    <>

                                        <Row>
                                            <Col xl="12" md="12" className="pl-2 pr-2">
                                                <table
                                                    borderless
                                                    style={{
                                                        borderCollapse: "collapse",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <thead
                                                        style={{
                                                            background: "#f2f2f2",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <tr>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {"Particulars"}
                                                            </th>
                                                            <th
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {"Amount (INR)"}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ fontSize: "14px" }}>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                Total Documents
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {calculation?.total_documents || 0}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {`Total Cost`}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {convertToRupees(
                                                                    calculation?.total_premium_amount || 0,
                                                                    true
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {`Total Commission`}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {convertToRupees(
                                                                    calculation?.total_commission_amount || 0,
                                                                    true
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {`Total Amount`}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {convertToRupees(
                                                                    calculation?.base_amount_payable || 0,
                                                                    true
                                                                )}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {"GST @ 18%"}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {convertToRupees(calculation?.gst_amount || 0)}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                }}
                                                            >
                                                                {"TDS @ 2%"}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {convertToRupees(calculation?.tds_amount || 0)}
                                                            </td>
                                                        </tr>

                                                        {/* Cancelled documents details - only show entire CN section if there are cancelled documents */}
                                                        {calculation?.total_cancelled_documents > 0 && (
                                                            <>
                                                                <tr>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "left",
                                                                        }}
                                                                        className="mb-1"
                                                                    >
                                                                        {"Invoice Gross Payable"}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "center",
                                                                        }}
                                                                        className="mb-2"
                                                                    >
                                                                        {convertToRupees(
                                                                            calculation?.net_payable_amount || 0,
                                                                            true
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="2" style={{ border: "1px solid #ddd", padding: "6px 8px", backgroundColor: "#fff3cd", fontWeight: "bold", fontSize: "12px", color: "#856404" }}>
                                                                        CN (Cancelled Documents) Details
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                                        Total Cancelled Documents
                                                                    </td>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                                                        {calculation?.total_cancelled_documents}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                                        Total Cancelled Cost
                                                                    </td>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                                                        {convertToRupees(calculation?.total_premium_amount_of_cancelled_documents || 0, true)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                                        Total MSC CN
                                                                    </td>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                                                        {convertToRupees(calculation?.total_commission_amount_of_cancelled_documents || 0, true)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                                        CN Gross Payable
                                                                    </td>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                                                        {convertToRupees(calculation?.base_amount_payable_for_cancelled_documents || 0, true)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                                        GST (18%)
                                                                    </td>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                                                        {convertToRupees(calculation?.gst_amount_for_cancelled_documents || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                                                        TDS @ 2%
                                                                    </td>
                                                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                                                        {convertToRupees(calculation?.tds_amount_for_cancelled_documents || 0)}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )}
                                                    </tbody>

                                                    <tfoot>
                                                        {calculation?.total_cancelled_documents > 0 && (
                                                            <tr>
                                                                <td
                                                                    style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}
                                                                    className="mb-1"
                                                                >
                                                                    {"Gross CN Amount"}
                                                                </td>
                                                                <td
                                                                    style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}
                                                                    className="mb-2"
                                                                >
                                                                    {convertToRupees(calculation?.net_payable_amount_for_cancelled_documents || 0, true)}
                                                                </td>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "left",
                                                                    fontWeight: "bold",
                                                                }}
                                                                className="mb-1"
                                                            >
                                                                {"Total Amount Payable"}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                    fontWeight: "bold",
                                                                    color: "#28a745",
                                                                }}
                                                                className="mb-2"
                                                            >
                                                                {convertToRupees(
                                                                    calculation?.net_payable_amount_for_cancelled_documents
                                                                        ? calculation?.net_payable_amount -
                                                                        calculation?.net_payable_amount_for_cancelled_documents
                                                                        : calculation?.net_payable_amount || 0,
                                                                    true
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-center mt-3">
                                                <Button
                                                    color="success"
                                                    size="md"
                                                    onClick={handleNext}
                                                    disabled={processing || redirecting}
                                                >
                                                    {processing ? "Processing..." : redirecting ? "Redirecting..." : "Next"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </ModalBody>
                        </>

                    )}

                    {activeStep === 1 && (
                        <>
                            <ModalHeader toggle={toggle} className="pb-0 mb-0 border-0">
                                {loading ? "Loading..." : "Confirm Commission invoice Creation and Proceed to Pay."}
                            </ModalHeader>
                            <ModalBody>
                                {loading ? (
                                    <GetLoader />
                                ) : errorMessage ? (
                                    <div className="text-center text-danger">
                                        <h5>{errorMessage}</h5>
                                        <Button color="danger" onClick={toggle}>
                                            Close
                                        </Button>
                                    </div>
                                ) : (
                                    <>
                                        <Form onSubmit={(e) => e.preventDefault()}>
                                            <Row>
                                                <Col xl="12" md="12" className="pl-2 pr-2">
                                                    <table
                                                        borderless
                                                        style={{
                                                            borderCollapse: "collapse",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <thead
                                                            style={{
                                                                background: "#f2f2f2",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            <tr>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Document No."}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Premium Amount (INR)"}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Commission Amount (INR)"}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Payable Amount without taxes (INR)"}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"GST 18% (INR)"}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"TDS 2% (INR)"}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Amount Payable (INR)"}
                                                                </th>
                                                                <th
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Status"}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontSize: "14px" }}>
                                                            {documentCommissionDetails?.map((doc, index) => (
                                                                <tr key={index}>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "left",
                                                                        }}
                                                                    >
                                                                        {doc.documentCode}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        {convertToRupees(doc?.memberPremium || 0, true)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        {convertToRupees(doc?.commissionAmount || 0, true)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        {convertToRupees(doc?.baseAmount || 0, true)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        {convertToRupees(doc?.gstAmount || 0, true)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        {convertToRupees(doc?.tdsAmount || 0, true)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "right",
                                                                        }}
                                                                    >
                                                                        {convertToRupees(doc?.netPayableAmt || 0, true)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "8px",
                                                                            textAlign: "left",
                                                                        }}
                                                                    >
                                                                        <Badge
                                                                            color={
                                                                                doc.status?.toUpperCase() === "ACTIVE"
                                                                                    ? "success"
                                                                                    : "warning"
                                                                            }
                                                                        >
                                                                            {doc.status}
                                                                        </Badge>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "left",
                                                                    }}
                                                                    className="mb-1"
                                                                >
                                                                    {"Grand Total"}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {convertToRupees(
                                                                        calculation?.total_premium_amount_of_cancelled_documents
                                                                            ? calculation?.total_premium_amount - calculation?.total_premium_amount_of_cancelled_documents
                                                                            : calculation?.total_premium_amount || 0,
                                                                        true
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {convertToRupees(
                                                                        calculation?.total_commission_amount_of_cancelled_documents
                                                                            ? calculation?.total_commission_amount - calculation?.total_commission_amount_of_cancelled_documents
                                                                            : calculation?.total_commission_amount || 0,
                                                                        true
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {convertToRupees(
                                                                        calculation?.base_amount_payable_for_cancelled_documents
                                                                            ? calculation?.base_amount_payable - calculation?.base_amount_payable_for_cancelled_documents
                                                                            : calculation?.base_amount_payable || 0,
                                                                        true
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {convertToRupees(
                                                                        calculation?.gst_amount_for_cancelled_documents
                                                                            ? calculation?.gst_amount - calculation?.gst_amount_for_cancelled_documents
                                                                            : calculation?.gst_amount || 0,
                                                                        true
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {convertToRupees(
                                                                        calculation?.tds_amount_for_cancelled_documents
                                                                            ? calculation?.tds_amount - calculation?.tds_amount_for_cancelled_documents
                                                                            : calculation?.tds_amount || 0,
                                                                        true
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: "1px solid #ddd",
                                                                        padding: "8px",
                                                                        textAlign: "right",
                                                                    }}
                                                                >
                                                                    {convertToRupees(
                                                                        calculation?.net_payable_amount_for_cancelled_documents
                                                                            ? calculation?.net_payable_amount - calculation?.net_payable_amount_for_cancelled_documents
                                                                            : calculation?.net_payable_amount || 0,
                                                                        true
                                                                    )}
                                                                </td>
                                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}></td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="text-left mt-3">
                                                    {isGSTReg === true && (
                                                        <Row className="mt-2">
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label for="invoiceNumber">Invoice Number</Label>
                                                                    <Input
                                                                        type="text"
                                                                        id="invoiceNumber"
                                                                        name="invoiceNumber"
                                                                        value={invoiceNumber}
                                                                        onChange={(e) => handleInvoiceNumberChange(e.target.value)}
                                                                        innerRef={register({ required: isGSTReg })}
                                                                        placeholder="Enter invoice number"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </Col>
                                            </Row>
                                            {!offlinePayment && (
                                                <Row>
                                                    <Col xl="12" md="12" className="text-left">
                                                        <FormGroup>
                                                            <span>
                                                                <strong>Note:</strong> As you proceed with the payment, a commission invoice should be generated concurrently for the corresponding transaction. You can find Commission invoices in Commission tab.
                                                            </span>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            )}
                                            {!offlinePayment ? (
                                                <Row>
                                                    <Col className="text-left mt-3">
                                                        <FormGroup check className="mt-3">
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={termsAccepted}
                                                                    onChange={() => setTermsAccepted(!termsAccepted)}
                                                                />{' '}
                                                                I've read the <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        toggleTermsModal();
                                                                    }}
                                                                    style={{
                                                                        color: '#007bff',
                                                                        textDecoration: 'underline'
                                                                    }}
                                                                >
                                                                    terms & conditions
                                                                </a>
                                                            </Label>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col className="text-right mt-3">
                                                        <Button
                                                            color="success"
                                                            size="md"
                                                            onClick={handleProceedToPay}
                                                            disabled={!termsAccepted || processing || redirecting}
                                                        >
                                                            {processing ? "Processing..." : redirecting ? "Redirecting..." : "Proceed to Pay"}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row>
                                                    {/* Remark Field */}
                                                    <Col xl="4" md="4" className="mt-3">
                                                        <FormGroup>
                                                            <Label for="remark">
                                                                Remark (<span style={{ color: "red" }}>* required</span>)
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                id="remark"
                                                                name="remark"
                                                                innerRef={register({ required: true })}
                                                                placeholder="Enter Remark"
                                                                onChange={(e) => {
                                                                    setValue("remark", e.target.value);
                                                                    setRemark(e.target.value);
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    {/* File Upload */}
                                                    <Col xl="4" md="4" className="mt-3">
                                                        <FileUploadComponent
                                                            register={register}
                                                            name="file"
                                                            setValue={setValue}
                                                            trigger={trigger}
                                                            getValues={getValues}
                                                            data={""}
                                                            add={getValues("file")?.length > 0 ? false : true}
                                                        />
                                                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                                                            * File is required
                                                        </div>
                                                    </Col>

                                                    {/* Terms & Conditions */}
                                                    <Col xl="4" md="4" className="mt-3">
                                                        <FormGroup check>
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={termsAccepted}
                                                                    onChange={() => setTermsAccepted(!termsAccepted)}
                                                                />{' '}
                                                                I've read the <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        toggleTermsModal();
                                                                    }}
                                                                    style={{
                                                                        color: '#007bff',
                                                                        textDecoration: 'underline'
                                                                    }}
                                                                >
                                                                    terms & conditions
                                                                </a>
                                                            </Label>
                                                        </FormGroup>
                                                    </Col>

                                                    {/* Submit Button */}
                                                    <Col className="text-right mt-3">
                                                        <Button
                                                            color="success"
                                                            size="md"
                                                            onClick={handleOfflineSubmit}
                                                            disabled={
                                                                isSubmitting ||
                                                                !(
                                                                    remark?.trim() &&
                                                                    getValues("file")?.length &&
                                                                    termsAccepted
                                                                )
                                                            }
                                                        >
                                                            {isSubmitting ? "Submitting..." : "Proceed to Finance"}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            )}
                                        </Form>
                                    </>
                                )}
                            </ModalBody>
                        </>
                    )}

                </div>
            </Modal>

            {/* Terms and Conditions Modal */}
            <Modal isOpen={termsModalOpen} toggle={toggleTermsModal} size="lg">
                <ModalHeader toggle={toggleTermsModal}>Terms and Conditions</ModalHeader>
                <ModalBody sx={{ maxHeight: '400px', overflowY: 'auto', scrollbarWidth: "none", msOverflowStyle: "none" }}>
                    <p>I hereby agree that I am the Authorized Signatory of Proprietorship / Partnership Firm / Company/ LLP (hereinafter referred as "Entity") duly authorized to digitally sign the invoices, and receive One Time Password (OTP) on my registered mobile number for business purpose on behalf of the said Entity. I hereby provide my consent for the above and to receive OTP on the said number to authenticate details on behalf of the Entity. I understand and agree that the OTP provided herein;</p>

                    <p>- shall be used only for the purpose of authenticating the identity of the Authorized Signatory on behalf of the said Entity through the Mobile based OTP system.,</p>
                    <p>- shall be used to avail my consent for digitally signing the invoices (using my Digital Signature) specific under this Travel Care  / Paperless arrangement with Europ Assistance India Private Limited ("EAI") and not for any other purpose otherwise.</p>
                    <p>I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it. I hereby authorize sharing of the information furnished herewith to be used for business purpose agreed herein.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleTermsModal}>Close</Button>
                    <Button color="primary" onClick={handleAgreeClick}>I Agree</Button>
                </ModalFooter>
            </Modal>

            {/* <Modal isOpen={otpModalOpen} toggle={toggleOtpModal} size="md">
        <ModalHeader toggle={toggleOtpModal}>OTP is shared to {businessPartnerInfo.phone_number}.</ModalHeader>
        <ModalBody style={{ maxHeight: '50%', overflowY: 'auto' }}>
          <Row>
            <Col xs="8">
              <FormGroup>
                <Label for="otp">Submit your OTP!</Label>
                <OtpInput
                  value={state.otp}
                  onChange={handleChange}
                  numInputs={6}
                  separator={<span style={{ width: '12px' }}></span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  inputStyle={{
                    border: '1px solid #CFD3DB ',
                    borderRadius: '9px',
                    width: '50px',
                    height: '50px',
                    fontSize: '16px',
                    fontWeight: '400',
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="1">
              <Button
                color="primary"
                size="md"
                type="submit"
                onClick={handleProceedToPayViaOtp}
                disabled={loading ? loading : loading}
              >
                {processing ? "Processing..." : redirecting ? "Redirecting..." : "Submit"}

              </Button>
            </Col>
          </Row>

        </ModalBody>
      </Modal> */}

        </Fragment>
    );
};

export default PayBulkInvoiceNormalWallet;
